module.exports = __webpack_public_path__ + "img/-s-pic_product zdyw_NO 05.b72a3853.svg";